module.exports = __webpack_public_path__ + "img/Parallel.d60e5199.svg";